export const clearClipboard = 'cube:clearClipboard';
export const clearClipboardEvent = new CustomEvent(clearClipboard);
